import { StorePickupPackageProvider } from './context/StorePickupPackageContext';
import { StorePickupPackageLayout } from './components';

export const StorePickupPackage = () => {
    return (
        <StorePickupPackageProvider>
            <StorePickupPackageLayout />
        </StorePickupPackageProvider>
    );
};
